import ApplicationLoader from "@/containers";

import PollContainer from "./PollContainer";

const AppLoader = new ApplicationLoader(PollContainer);

AppLoader.start();
